import StarIcon from '@mui/icons-material/Star';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, ButtonProps } from 'shared/mui/Buttons';
import { Tooltip } from 'shared/mui/Tooltip';

export type FilterFavouriteButtonProps = ButtonProps;

export const FilterFavoriteButton: React.FC<FilterFavouriteButtonProps> = ({
  label,
  color = 'secondary',
  disabled,
  ...restProps
}) => {
  const translate = useTypedTranslate();

  return (
    <Tooltip
      arrow
      title={
        disabled ? (
          <>
            {translate('app.buttons.noSettings')}. <br />{' '}
            {translate('app.buttons.addFilterSettingsViaFilter')}
          </>
        ) : undefined
      }
    >
      <span>
        <Button
          color={color}
          disabled={disabled}
          label={label || translate('app.buttons.favorite')}
          startIcon={<StarIcon />}
          {...restProps}
        />
      </span>
    </Tooltip>
  );
};
